import Licenses from "./Licenses";    

export default Licenses;